import Home from '../components/Home'
import Login from '../components/Login'
import MyPage from '../components/MyPage'
import Access from '../components/Access'
import Message from '../components/Message'
import ShopList from '../components/ShopList'
import ShopNew from '../components/ShopNew'
import ShopEdit from '../components/ShopEdit'
import ShopDetail from '../components/ShopDetail'
import ShopUserList from '../components/ShopUserList'
import Other from '../components/Other'
import UserList from '../components/UserList'
import UserDetail from '../components/UserDetail'
import UserNew from '../components/UserNew'
import UserEdit from '../components/UserEdit'
import UserOver from '../components/UserOver'
import UserPdf from '../components/UserPdf'
import Master from '../components/Master'
import RetireeList from '../components/RetireeList'
import UserChangeList from '../components/UserChangeList'
import UserPhotoList from '../components/UserPhotoList'
import UserTypeList from '../components/UserTypeList'
import UserTypeNew from '../components/UserTypeNew'
import UserTypeEdit from '../components/UserTypeEdit'
import UserHistory from '../components/UserHistory'
import ShopHistoryEdit from '../components/ShopHistoryEdit'
import ShopHistoryForceEdit from '../components/ShopHistoryForceEdit'
import UsertypeHistoryEdit from '../components/UsertypeHistoryEdit'
import UsertypeHistoryForceEdit from '../components/UsertypeHistoryForceEdit'
import DomainList from '../components/DomainList'
import DomainNew from '../components/DomainNew'
import DomainEdit from '../components/DomainEdit'
import BusinessTypeList from '../components/BusinessTypeList'
import BusinessTypeNew from '../components/BusinessTypeNew'
import BusinessTypeEdit from '../components/BusinessTypeEdit'
import TurnoverTypeList from '../components/TurnoverTypeList'
import TurnoverTypeNew from '../components/TurnoverTypeNew'
import TurnoverTypeEdit from '../components/TurnoverTypeEdit'
import JoinList from '../components/JoinList'
import JoinNew from '../components/JoinNew'
import JoinEdit from '../components/JoinEdit'
import ForgotPassword from '../components/ForgotPassword'
import ResetPassword from '../components/ResetPassword'
import Moral from '../components/Moral'
import MoralList from '../components/MoralList'
import MoralDetail from '../components/MoralDetail'
import MoralNew from '../components/MoralNew'
import MoralEdit from '../components/MoralEdit'
import MoralResultList from '../components/MoralResultList'
import Propose from '../components/Propose'
import ProposeUnapprovedList from '../components/ProposeUnapprovedList'
import ProposeApprovedList from '../components/ProposeApprovedList'
import ProposeUnapprovedDetail from '../components/ProposeUnapprovedDetail'
import ProposeApprovedDetail from '../components/ProposeApprovedDetail'
import ProposeTaskList from '../components/ProposeTaskList'
import ProposeTaskDetail from '../components/ProposeTaskDetail'
import ProposeTaskNew from '../components/ProposeTaskNew'
import ProposeTaskEdit from '../components/ProposeTaskEdit'
import ProposeResult from '../components/ProposeResult'
import DeadlineNotice from '../components/DeadlineNotice'
import DocumentRenewalList from '../components/DocumentRenewalList'
import DocumentRenewalDetail from '../components/DocumentRenewalDetail'
import PayrollList from '../components/PayrollList'
import RejectReasonList from '../components/RejectReasonList'
import RejectReasonNew from '../components/RejectReasonNew'
import RejectReasonEdit from '../components/RejectReasonEdit'
import GuidelineList from '../components/GuidelineList'
import GuidelineNew from '../components/GuidelineNew'
import GuidelineEdit from '../components/GuidelineEdit'
import ShopManagerList from '../components/ShopManagerList'
import ShopManagerEdit from '../components/ShopManagerEdit'
import ShiftManage from '../components/ShiftManage'
import OnboardingList from '../components/OnboardingList'
import OnboardingNew from '../components/OnboardingNew'
import OnboardingDetail from '../components/OnboardingDetail'
import ShiftAttendance from '../components/ShiftAttendance'
import ShiftCreate from '../components/ShiftCreate'
import ShiftClass from '../components/ShiftClass'
import ShiftCondition from '../components/ShiftCondition'
import ShiftConditionEdit from '../components/ShiftConditionEdit'
import ShiftCreatorList from '../components/ShiftCreatorList'
import ShiftCreatorEdit from '../components/ShiftCreatorEdit'
import MagazineList from '../components/MagazineList'
import MagazineNew from '../components/MagazineNew'
import MagazineEdit from '../components/MagazineEdit'
import HumanStaffList from '../components/HumanStaffList'
import WillMust from '../components/WillMust'
import WillMustAdmin from '../components/WillMustAdmin'
import ReferralList from '../components/ReferralList'
import ReferralEdit from '../components/ReferralEdit'
import IntroductionList from '../components/IntroductionList'
import IntroductionDetail from '../components/IntroductionDetail'
import QuestionList from '../components/QuestionList'
import QuestionNew from '../components/QuestionNew'
import QuestionEdit from '../components/QuestionEdit'
import QuestionDetail from '../components/QuestionDetail'
import Stepup from '../components/Stepup'
import StepupList from '../components/StepupList'
import StepupNew from '../components/StepupNew'
import StepupDetail from '../components/StepupDetail'
import StepupEdit from '../components/StepupEdit'
import StepupResultList from '../components/StepupResultList'
import EsMycardResult from '../components/EsMycardResult'
import CompanyNotice from '../components/CompanyNotice'
import CompanyNoticeList from '../components/CompanyNoticeList'
import CompanyNoticeDetail from '../components/CompanyNoticeDetail'
import CompanyNoticeNew from '../components/CompanyNoticeNew'
import CompanyNoticeEdit from '../components/CompanyNoticeEdit'
import CompanyNoticeResult from '../components/CompanyNoticeResult'
import Stock from '../components/Stock'
import MasterStock from '../components/MasterStock'
import MasterSupplierList from '../components/MasterSupplierList'
import MasterSupplierDetail from '../components/MasterSupplierDetail'
import MasterSupplierNew from '../components/MasterSupplierNew'
import MasterSupplierEdit from '../components/MasterSupplierEdit'
import MasterConsumableItemList from '../components/MasterConsumableItemList'
import MasterConsumableItemNew from '../components/MasterConsumableItemNew'
import MasterConsumableItemDetail from '../components/MasterConsumableItemDetail'
import MasterConsumableItemEdit from '../components/MasterConsumableItemEdit'
import MasterConsumableItemShopStockCountList from '../components/MasterConsumableItemShopStockCountList'
import MasterConsumableItemShopStockCountEdit from '../components/MasterConsumableItemShopStockCountEdit'
import MasterCategoryList from '../components/MasterCategoryList'
import MasterCategoryNew from '../components/MasterCategoryNew'
import MasterCategoryEdit from '../components/MasterCategoryEdit'
import MasterShopHoldOnPlaceList from '../components/MasterShopHoldOnPlaceList'
import MasterTanomailList from '../components/MasterTanomailList'
import MasterTanomailNew from '../components/MasterTanomailNew'
import MasterTanomailEdit from '../components/MasterTanomailEdit'
import ShopOrderList from '../components/ShopOrderList'
import ShopOrderDetail from '../components/ShopOrderDetail'
import ShopOrderHistoryList from '../components/ShopOrderHistoryList'
import ShopOrderHistoryDetail from '../components/ShopOrderHistoryDetail'
import StockOutput from '../components/StockOutput'
import StockAnalysis from '../components/StockAnalysis'
import NormalQuestionList from '../components/NormalQuestionList'
import NormalQuestionNew from '../components/NormalQuestionNew'
import NormalQuestionDetail from '../components/NormalQuestionDetail'
import NormalQuestionEdit from '../components/NormalQuestionEdit'
import AbilityQuestionList from '../components/AbilityQuestionList'
import AbilityQuestionNew from '../components/AbilityQuestionNew'
import AbilityQuestionDetail from '../components/AbilityQuestionDetail'
import AbilityQuestionEdit from '../components/AbilityQuestionEdit'
import EvaluateQuestion from '../components/EvaluateQuestion'
import EvaluateQuestionList from '../components/EvaluateQuestionList'
import EvaluateQuestionResultList from '../components/EvaluateQuestionResultList'
import EvaluateQuestionNew from '../components/EvaluateQuestionNew'
import EvaluateQuestionDetail from '../components/EvaluateQuestionDetail'
import EvaluateQuestionEdit from '../components/EvaluateQuestionEdit'
import MasterServiceQuestionList from '../components/MasterServiceQuestionList'
import MasterServiceQuestionNew from '../components/MasterServiceQuestionNew'
import MasterServiceQuestionDetail from '../components/MasterServiceQuestionDetail'
import MasterServiceQuestionEdit from '../components/MasterServiceQuestionEdit'
import ServiceQuestion from '../components/ServiceQuestion'
import ServiceQuestionList from '../components/ServiceQuestionList'
import ServiceQuestionNew from '../components/ServiceQuestionNew'
import ServiceQuestionEdit from '../components/ServiceQuestionEdit'
import ServiceQuestionResultList from '../components/ServiceQuestionResultList'
import ServiceQuestionResultDetail from '../components/ServiceQuestionResultDetail'
import ServiceQuestionMovie from '../components/ServiceQuestionMovie'
import ServiceQuestionShopResultList from '../components/ServiceQuestionShopResultList'
import MachineOrderShop from '../components/MachineOrderShop.vue'
import SafetyConfirmationList from '../components/SafetyConfirmationList'
import SafetyConfirmationEdit from '../components/SafetyConfirmationEdit'
import SafetyConfirmationAnswerList from '../components/SafetyConfirmationAnswerList'

export default {
  data: [
    {name: 'home', path: '/', component: Home},
    {name: 'myPage', path: '/mypage', component: MyPage},
    {name: 'login', path: '/login', component: Login, meta: {noAuth: true}},
    {name: 'forgotPassword', path: '/forgot_password', component: ForgotPassword, meta: {noAuth: true}},
    {name: 'resetPassword', path: '/reset_password', component: ResetPassword, meta: {noAuth: true}},
    {name: 'access', path: '/access', component: Access}, // アクセス連携
    {name: 'message', path: '/message', component: Message}, // メッセージ確認
    {name: 'shopList', path: '/shops', component: ShopList}, // 店舗 一覧
    {name: 'shopNew', path: '/shops/new', component: ShopNew}, // 店舗 新規登録
    {name: 'shopDetail', path: '/shops/:id', component: ShopDetail}, // 店舗 詳細
    {name: 'shopEdit', path: '/shops/:id/edit', component: ShopEdit}, // 店舗 編集
    {name: 'shopUserList', path: '/shops/:id/users', component: ShopUserList}, // 店舗 社員一覧
    {name: 'userList', path: '/users', component: UserList}, // 社員 一覧
    {name: 'UserNew', path: '/users/new', component: UserNew}, // 社員 新規登録
    {name: 'userDetail', path: '/users/:id', component: UserDetail}, // 社員 詳細
    {name: 'UserEdit', path: '/users/:id/edit', component: UserEdit}, // 社員組織 修正
    {name: 'userOver', path: '/users/:id/over', component: UserOver}, // 離職登録
    {name: 'UserPdf', path: '/users/:id/pdf', component: UserPdf}, // 各種PDF 資料
    {name: 'master', path: '/master', component: Master}, // マスタ管理
    {name: 'retireeList', path: '/retiree', component: RetireeList}, // 退職者 一覧
    {name: 'userChangeList', path: '/userchanges', component: UserChangeList}, // 役職異動日 一覧
    {name: 'userPhotoList', path: '/userphotos', component: UserPhotoList}, // 写真 一覧
    {name: 'usertypeList', path: '/user_types', component: UserTypeList}, // 役職 一覧
    {name: 'usertypeNew', path: '/user_types/new', component: UserTypeNew}, // 役職 新規登録
    {name: 'usertypeEdit', path: '/user_types/:id/edit', component: UserTypeEdit}, // 役職 編集
    {name: 'userHistory', path: '/userhistory/:id', component: UserHistory}, // 履歴確認
    {name: 'ShopHistoryEdit', path: '/shophistory/:id', component: ShopHistoryEdit}, // 店舗異動
    {name: 'ShopHistoryForceEdit', path: '/shopforcehistory/:id', component: ShopHistoryForceEdit}, // 店舗履歴編集
    {name: 'UsertypeHistoryEdit', path: '/usertypehistory/:id', component: UsertypeHistoryEdit}, // 役職異動
    {name: 'UsertypeHistoryForceEdit', path: '/usertypeforcehistory/:id', component: UsertypeHistoryForceEdit}, // 役職履歴編集
    {name: 'domainList', path: '/domains', component: DomainList}, // ドメイン 一覧
    {name: 'domainNew', path: '/domains/new', component: DomainNew}, // ドメイン 新規登録
    {name: 'domainEdit', path: '/domains/:id/edit', component: DomainEdit}, // ドメイン 編集
    {name: 'businesstypeList', path: '/business_types', component: BusinessTypeList}, // 業務内容 一覧
    {name: 'businesstypeNew', path: '/business_types/new', component: BusinessTypeNew}, // 業務内容 新規登録
    {name: 'businesstypeEdit', path: '/business_types/:id/edit', component: BusinessTypeEdit}, // 業務内容 編集
    {name: 'turnovertypeList', path: '/turnover_types', component: TurnoverTypeList}, // 離職事由 一覧
    {name: 'turnovertypeNew', path: '/turnover_types/new', component: TurnoverTypeNew}, // 離職事由 新規登録
    {name: 'turnovertypeEdit', path: '/turnover_types/:id/edit', component: TurnoverTypeEdit}, // 離職事由 編集
    {name: 'joinList', path: '/joins', component: JoinList}, // 入社経緯 一覧
    {name: 'joinNew', path: '/joins/new', component: JoinNew}, // 入社経緯 新規登録
    {name: 'joinEdit', path: '/joins/:id/edit', component: JoinEdit}, // 入社経緯 編集
    {name: 'moral', path: '/morals', component: Moral}, // モラル確認
    {name: 'moralList', path: '/moral_list', component: MoralList}, // モラル確認管理
    {name: 'moralNew', path: '/morals/new', component: MoralNew}, // モラル確認新規
    {name: 'moralDetail', path: '/morals/:id', component: MoralDetail}, // モラル確認 詳細
    {name: 'moralEdit', path: '/morals/:id/edit', component: MoralEdit}, // モラル確認編集
    {name: 'moralResultList', path: '/moral_result_list', component: MoralResultList}, // モラル結果一覧
    {name: 'propose', path: '/proposes', component: Propose}, // 提案制度
    {name: 'proposeUnapprovedList', path: '/propose_unapproved_list', component: ProposeUnapprovedList}, // 承認前提案投稿一覧
    {name: 'proposeApprovedList', path: '/propose_before_adopt_list', component: ProposeApprovedList}, // 採用前提案投稿一覧
    {name: 'proposeUnapprovedDetail', path: '/propose_unapproved/:id', component: ProposeUnapprovedDetail}, // 提案詳細
    {name: 'proposeApprovedDetail', path: '/propose_before_adopt/:id', component: ProposeApprovedDetail}, // 提案詳細
    {name: 'proposeResult', path: '/propose_result', component: ProposeResult}, // 提案投稿集計抽出
    {name: 'proposeTaskList', path: '/propose_task_list', component: ProposeTaskList}, // 議題提案
    {name: 'proposeTaskNew', path: '/propose_task/new', component: ProposeTaskNew}, // 議題提案作成
    {name: 'proposeTaskDetail', path: '/propose_task/:id', component: ProposeTaskDetail}, // 議題提案詳細
    {name: 'proposeTaskEdit', path: '/propose_task/:id/edit', component: ProposeTaskEdit}, // 議題提案編集
    {name: 'deadlineNotice', path: '/deadline_notices', component: DeadlineNotice}, // 期限日お知らせ
    {name: 'documentRenewalList', path: '/document_renewals', component: DocumentRenewalList}, // 書類更新 提出一覧
    {name: 'documentRenewalDetail', path: '/document_renewals/:id', component: DocumentRenewalDetail}, // 書類更新 確認
    {name: 'payrollList', path: '/payroll_documents', component: PayrollList}, // 給与・賞与明細（一覧・取込）
    {name: 'rejectreasonList', path: '/reject_reasons', component: RejectReasonList}, // 却下理由 一覧
    {name: 'rejectreasonNew', path: '/reject_reasons/new', component: RejectReasonNew}, // 却下理由 新規登録
    {name: 'rejectreasonEdit', path: '/reject_reasons/:id/edit', component: RejectReasonEdit}, // 却下理由 編集
    {name: 'guidelineList', path: '/guidelines', component: GuidelineList}, // 行動指針 一覧
    {name: 'guidelineNew', path: '/guidelines/new', component: GuidelineNew}, // 行動指針 新規登録
    {name: 'guidelineEdit', path: '/guidelines/:id/edit', component: GuidelineEdit}, // 行動指針 編集
    {name: 'shopManagerList', path: '/shop_managers', component: ShopManagerList}, // 店舗管理者 一覧
    {name: 'shopManagerEdit', path: '/shop_managers/:id/edit', component: ShopManagerEdit}, // 店舗管理者 編集
    {name: 'shiftManage', path: '/shift_manage', component: ShiftManage}, // シフト管理画面
    {name: 'onboardingList', path: '/onboarding', component: OnboardingList}, // 入社手続き 対象者一覧（F-NEW）
    {name: 'onboardingNew', path: '/onboarding/new', component: OnboardingNew}, // 新入社員 仮登録（F-NEW-01）
    {name: 'onboardingDetail', path: '/onboarding/:id', component: OnboardingDetail}, // 入社手続き 確認・承認（F-NEW-05）
    {name: 'shiftAttendance', path: '/shift_attendance', component: ShiftAttendance}, // 出勤簿出力
    {name: 'shiftCreate', path: '/shift_create', component: ShiftCreate}, // シフト作成画面
    {name: 'shiftClass', path: '/shift_class', component: ShiftClass}, // シフト条件 詳細&編集
    {name: 'shiftCondition', path: '/shift_condition', component: ShiftCondition}, // シフト条件一覧画面
    {name: 'shiftConditionEdit', path: '/shift_condition/:id/edit', component: ShiftConditionEdit}, // シフト条件編集画面
    {name: 'shiftCreatorList', path: '/shift_creators', component: ShiftCreatorList}, // シフト作成者 一覧
    {name: 'shiftCreatorEdit', path: '/shift_creators/:id/edit', component: ShiftCreatorEdit}, // シフト作成者 編集
    {name: 'magazineList', path: '/magazines', component: MagazineList}, // 社内報 一覧
    {name: 'magazineNew', path: '/magazines/new', component: MagazineNew}, // 社内報 新規登録
    {name: 'magazineEdit', path: '/magazines/:id/edit', component: MagazineEdit}, // 社内報 編集
    {name: 'HumanStaffList', path: '/human_staffs', component: HumanStaffList}, // 人事担当者 一覧
    {name: 'WillMust', path: '/will_must', component: WillMust}, // will-must
    {name: 'WillMustAdmin', path: '/will_must_admin', component: WillMustAdmin}, // will-must-admin
    {name: 'ReferralList', path: '/referral', component: ReferralList}, // 友人紹介
    {name: 'ReferralEdit', path: '/referral/:referral_id/edit', component: ReferralEdit}, // 友人紹介内容編集
    {name: 'IntroductionList', path: '/introduction', component: IntroductionList}, // 友人紹介結果一覧
    {name: 'IntroductionDetail', path: '/introduction/:introduction_id', component: IntroductionDetail}, // 友人紹介結果詳細
    {name: 'QuestionList', path: '/question', component: QuestionList}, // 評価一覧
    {name: 'QuestionNew', path: '/question/new', component: QuestionNew}, // 評価新規
    {name: 'QuestionEdit', path: '/question/:id/edit', component: QuestionEdit}, // 評価編集
    {name: 'QuestionDetail', path: '/question/:id', component: QuestionDetail}, // 評価詳細
    {name: 'Stepup', path: '/stepup', component: Stepup}, // ステップアップ
    {name: 'StepupList', path: '/stepup_list', component: StepupList}, // ステップアップ一覧
    {name: 'StepupNew', path: '/stepup/new', component: StepupNew}, // ステップアップ新規
    {name: 'StepupDetail', path: '/stepup/:id', component: StepupDetail}, // ステップアップ詳細
    {name: 'StepupEdit', path: '/stepup/:id/edit', component: StepupEdit}, // ステップアップ編集
    {name: 'StepupResultList', path: '/stepup_result_list', component: StepupResultList}, // ステップアップ結果一覧
    {name: 'EsMycardResult', path: '/es_mycard_result', component: EsMycardResult}, // esマイカード結果出力
    {name: 'CompanyNotice', path: '/company_notice', component: CompanyNotice},                                       // 全社通達
    {name: 'CompanyNoticeList', path: '/company_notice_list', component: CompanyNoticeList},                          // 全社通達一覧
    {name: 'CompanyNoticeDetail', path: '/company_notice/:company_notice_id/detail', component: CompanyNoticeDetail}, // 全社通達詳細
    {name: 'CompanyNoticeNew', path: '/company_notice/new', component: CompanyNoticeNew},                             // 全社通達登録
    {name: 'CompanyNoticeEdit', path: '/company_notice/:company_notice_id/edit', component: CompanyNoticeEdit},       // 全社通達編集
    {name: 'CompanyNoticeResult', path: '/company_notice_result', component: CompanyNoticeResult},                    // 全社通達集計
    {name: 'Stock', path: '/stock', component: Stock}, // 在庫管理
    {name: 'MasterStock', path: '/master_stock', component: MasterStock}, // 在庫管理マスタメニュー
    {name: 'MasterSupplierList', path: '/master_supplier_list', component: MasterSupplierList}, // サプライヤーマスタ一覧
    {name: 'MasterSupplierNew', path: '/master_supplier/new', component: MasterSupplierNew}, // サプライヤーマスタ新規登録
    {name: 'MasterSupplierDetail', path: '/master_supplier/:id', component: MasterSupplierDetail}, // サプライヤーマスタ一詳細
    {name: 'MasterSupplierEdit', path: '/master_supplier/:id/edit', component: MasterSupplierEdit}, // サプライヤー編集
    {name: 'MasterConsumableItemList', path: '/master_consumable_item_list', component: MasterConsumableItemList}, // 消耗品マスタ一覧
    {name: 'MasterConsumableItemNew', path: '/master_consumable_item/new', component: MasterConsumableItemNew}, // 消耗品マスタ新規
    {name: 'MasterConsumableItemEdit', path: '/master_consumable_item/:consumable_item_id/edit', component: MasterConsumableItemEdit}, // 消耗品マスタ編集
    {name: 'MasterConsumableItemDetail', path: '/master_consumable_item/:consumable_item_id', component: MasterConsumableItemDetail}, // 消耗品マスタ詳細
    {name: 'MasterConsumableItemShopStockCountList', path: '/master_consumable_item/:consumable_item_id/stock_count', component: MasterConsumableItemShopStockCountList}, // 店舗の消耗品必要在庫数一覧
    {name: 'MasterConsumableItemShopStockCountEdit', path: '/master_consumable_item/:consumable_item_id/stock_count/:shop_id/edit', component: MasterConsumableItemShopStockCountEdit}, // 店舗の消耗品必要在庫数編集
    {name: 'MasterCategoryList', path: '/master_category_list', component: MasterCategoryList}, // カテゴリーマスタ一覧
    {name: 'MasterCategoryNew', path: '/master_category/new', component: MasterCategoryNew}, // カテゴリー新規登録
    {name: 'MasterCategoryEdit', path: '/master_category/:id/edit', component: MasterCategoryEdit}, // カテゴリー編集
    {name: 'MasterShopHoldOnPlaceList', path: '/master_shop_hold_on_place_list', component: MasterShopHoldOnPlaceList}, // 保管場所マスタ一覧
    {name: 'MasterTanomailList', path: '/master_tanomail_list', component: MasterTanomailList}, // たのめーるアカウントマスタ一覧
    {name: 'MasterTanomailNew', path: '/master_tanomail/new', component: MasterTanomailNew}, // たのめーるアカウントマスタ新規登録
    {name: 'MasterTanomailEdit', path: '/master_tanomail/:id/edit', component: MasterTanomailEdit}, // たのめーるアカウント編集
    {name: 'ShopOrderList', path: '/shop_order_list', component: ShopOrderList}, // 店舗発注一覧
    {name: 'ShopOrderDetail', path: '/shop_order/:shop_order_id/detail', component: ShopOrderDetail}, // 店舗発注詳細
    {name: 'ShopOrderHistoryList', path: '/shop_order/history_list', component: ShopOrderHistoryList}, // 店舗発注履歴
    {name: 'ShopOrderHistoryDetail', path: '/shop_order/history/:shop_order_id/detail', component: ShopOrderHistoryDetail}, // 店舗発注履歴詳細
    {name: 'StockOutput', path: '/stock_output', component: StockOutput}, // 在庫管理出力
    {name: 'StockAnalysis', path: '/stock_analysis', component: StockAnalysis}, // 在庫分析
    {name: 'NormalQuestionList', path: '/normal_question', component: NormalQuestionList},
    {name: 'NormalQuestionNew', path: '/normal_question/new', component: NormalQuestionNew},
    {name: 'NormalQuestionDetail', path: '/normal_question/:id', component: NormalQuestionDetail},
    {name: 'NormalQuestionEdit', path: '/normal_question/:id/edit', component: NormalQuestionEdit}, // 評価編集
    {name: 'AbilityQuestionList', path: '/ability_question', component: AbilityQuestionList},
    {name: 'AbilityQuestionNew', path: '/ability_question/new', component: AbilityQuestionNew},
    {name: 'AbilityQuestionDetail', path: '/ability_question/:id', component: AbilityQuestionDetail},
    {name: 'AbilityQuestionEdit', path: '/ability_question/:id/edit', component: AbilityQuestionEdit},
    {name: 'EvaluateQuestion', path: '/evaluate_question', component: EvaluateQuestion},
    {name: 'EvaluateQuestionList', path: '/evaluate_question_list', component: EvaluateQuestionList},
    {name: 'EvaluateQuestionResultList', path: '/evaluate_question_result_list', component: EvaluateQuestionResultList},
    {name: 'EvaluateQuestionNew', path: '/evaluate_question/new', component: EvaluateQuestionNew},
    {name: 'EvaluateQuestionDetail', path: '/evaluate_question/:id', component: EvaluateQuestionDetail},
    {name: 'EvaluateQuestionEdit', path: '/evaluate_question/:id/edit', component: EvaluateQuestionEdit},
    {name: 'MasterServiceQuestionList', path: '/master/service_questions', component: MasterServiceQuestionList},
    {name: 'MasterServiceQuestionNew', path: '/master/service_questions/new', component: MasterServiceQuestionNew},
    {name: 'MasterServiceQuestionDetail', path: '/master/service_questions/:id', component: MasterServiceQuestionDetail},
    {name: 'MasterServiceQuestionEdit', path: '/master/service_questions/:id/edit', component: MasterServiceQuestionEdit},
    {name: 'ServiceQuestion', path: '/service_question', component: ServiceQuestion},
    {name: 'ServiceQuestionList', path: '/service_question/questions', component: ServiceQuestionList},
    {name: 'ServiceQuestionNew', path: '/service_question/questions/new', component: ServiceQuestionNew},
    {name: 'ServiceQuestionEdit', path: '/service_question/questions/:id/edit', component: ServiceQuestionEdit},
    {name: 'ServiceQuestionResultList', path: '/service_question/results', component: ServiceQuestionResultList},
    {name: 'ServiceQuestionResultDetail', path: '/service_question/results/:serviceQuestionId/:targetUserId/:answerStartDate', component: ServiceQuestionResultDetail},
    {name: 'ServiceQuestionMovie', path: '/service_question/movie', component: ServiceQuestionMovie},
    {name: 'ServiceQuestionShopResultList', path: '/service_question/shop_results', component: ServiceQuestionShopResultList},
    {name: 'MachineOrderShop', path: '/master/machine_order_shop', component: MachineOrderShop},
    {name: 'SafetyConfirmationList', path: '/safety_confirmations', component: SafetyConfirmationList},
    {name: 'SafetyConfirmationNew', path: '/safety_confirmations/new', component: SafetyConfirmationEdit},
    {name: 'SafetyConfirmationEdit', path: '/safety_confirmations/:id/edit', component: SafetyConfirmationEdit},
    {name: 'SafetyConfirmationAnswerList', path: '/safety_confirmations/:id/answers', component: SafetyConfirmationAnswerList},
    {name: 'other', path: '*', component: Other}
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes.js